import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
	TICKET_FETCH,
	TICKETS_FETCH,
	TICKETS_SERVICE_FETCH,
	TICKETS_SHOWROOM_FETCH,
	TICKETS_SERVICE_REPORT_STATUS_FETCH,
	TICKETS_SHOWROOM_REPORT_STATUS_FETCH,
	TICKETS_HOTSHEET_SERVICE_FETCH,
	TICKETS_HOTSHEET_SHOWROOM_FETCH,
	TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH,
	TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH,
	TICKETS_CALLCENTER_SERVICE_FETCH,
	TICKETS_CALLCENTER_SHOWROOM_FETCH,
	TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH,
	TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH,
	TICKET_CREATE,
	TICKET_UPDATE,
	TICKET_VERIFIED_UPDATE,
	TICKET_DELETE,
	TICKETS_EXPORT_EXCEL,
	TICKET_CANCEL,
	TICKET_LOGS_UPDATE
} from "../actions/types";
import {
	ticketFetchSuccess,
	ticketsFetchSuccess,
	ticketsServiceFetchSuccess,
	ticketsShowroomFetchSuccess,
	ticketsServiceReportStatusFetchSuccess,
	ticketsShowroomReportStatusFetchSuccess,
	ticketsHotSheetServiceFetchSuccess,
	ticketsHotSheetShowroomFetchSuccess,
	ticketsHotSheetServiceReportStatusFetchSuccess,
	ticketsHotSheetShowroomReportStatusFetchSuccess,
	ticketsCallCenterServiceFetchSuccess,
	ticketsCallCenterShowroomFetchSuccess,
	ticketsCallCenterServiceReportStatusFetchSuccess,
	ticketsCallCenterShowroomReportStatusFetchSuccess
} from "../actions/TicketActions";
import { showErrorMessage, showSuccessMessage, hideLoader } from "../actions/NotifyActions";
import { authorizationHeader, authorizationHeaderWithMultipartFormData, getErrorMessage } from "../util/apiUtil";
import { intl } from "../lngProvider/IntlGlobalProvider";
import { TICKET_D_STATUS } from "../constants/Systems";
import axios from "axios";
import FileSaver from "file-saver";
import moment from "moment";
import _ from "lodash";
import { reset } from "redux-form";
import { push } from "react-router-redux";
import { objectToFormData } from 'object-to-formdata';

// API
const ticketFetchRequest = async id =>
	await axios
		.get(`${process.env.REACT_APP_API_URL}/api/tickets/${id}`, {
			headers: authorizationHeader("bearer")
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});

const ticketsFetchRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);
	params.sort = "created_oa_date";
	params.order = "desc";

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

const ticketsReportStatusFetchRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/status`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

const ticketCreateRequest = async values => {
	const { imageFiles, pdfFiles, ...rest } = values;
	let formData = objectToFormData(rest);
	imageFiles.forEach(file => {
		formData.append('imageFiles[]', file);
	})
	pdfFiles.forEach(file => {
		formData.append('pdfFiles[]', file);
	})

	return await axios
		.post(`${process.env.REACT_APP_API_URL}/api/tickets`, formData, {
			headers: authorizationHeaderWithMultipartFormData("bearer")
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
}

const ticketUpdateRequest = async values => {
	const { imageFiles, pdfFiles, ...rest } = values;
	let formData = objectToFormData(rest);
	imageFiles.forEach(file => {
		formData.append('imageFiles[]', file);
	})
	pdfFiles.forEach(file => {
		formData.append('pdfFiles[]', file);
	})

	return await axios
		.put(`${process.env.REACT_APP_API_URL}/api/tickets/${values._id}`, formData, {
			headers: authorizationHeaderWithMultipartFormData("bearer")
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
}

const ticketVerifiedUpdateRequest = async values =>
	await axios
		.put(`${process.env.REACT_APP_API_URL}/api/tickets/verified/${values._id}`, values, {
			headers: authorizationHeader("bearer")
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});


const ticketDeleteRequest = async id =>
	await axios
		.delete(`${process.env.REACT_APP_API_URL}/api/tickets/${id}`, {
			headers: authorizationHeader("bearer")
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});

const ticketCancelRequest = async ({ _id, logs, cancel_description }) =>
	await axios.patch(`${process.env.REACT_APP_API_URL}/api/tickets/${_id}`, { status: TICKET_D_STATUS, logs, cancel_description }, {
		headers: authorizationHeader("bearer")
	})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});

const ticketLogsUpdateRequest = async ({ _id, logs }) =>
	await axios.patch(`${process.env.REACT_APP_API_URL}/api/tickets/${_id}`, { logs }, {
		headers: authorizationHeader("bearer")
	})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});

const ticketsExportExcelRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/excel`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params,
			responseType: "blob"
		})
		.then(response => {
			return response.data;
		})
		.catch(error => {
			throw error;
		});
};

// WORKER
function* ticketFetch({ payload }) {
	try {
		const data = yield call(ticketFetchRequest, payload);
		yield put(ticketFetchSuccess(data));
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketsFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsFetchRequest, payload);
		yield put(ticketsFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketsServiceFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsFetchRequest, payload);
		yield put(ticketsServiceFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketsShowroomFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsFetchRequest, payload);
		yield put(ticketsShowroomFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketsShowroomReportStatusFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsReportStatusFetchRequest, payload);
		yield put(ticketsShowroomReportStatusFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketsServiceReportStatusFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsReportStatusFetchRequest, payload);
		yield put(ticketsServiceReportStatusFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}
// ---------------------------------------------------------------------------------------------------------
function* ticketsHotSheetServiceFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsFetchRequest, payload);
		yield put(ticketsHotSheetServiceFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketsHotSheetShowroomFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsFetchRequest, payload);
		yield put(ticketsHotSheetShowroomFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketsHotSheetShowroomReportStatusFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsReportStatusFetchRequest, payload);
		yield put(ticketsHotSheetShowroomReportStatusFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketsHotSheetServiceReportStatusFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsReportStatusFetchRequest, payload);
		yield put(ticketsHotSheetServiceReportStatusFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}
// ---------------------------------------------------------------------------------------------------------
function* ticketsCallCenterServiceFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsFetchRequest, payload);
		yield put(ticketsCallCenterServiceFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketsCallCenterShowroomFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsFetchRequest, payload);
		yield put(ticketsCallCenterShowroomFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketsCallCenterShowroomReportStatusFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsReportStatusFetchRequest, payload);
		yield put(ticketsCallCenterShowroomReportStatusFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketsCallCenterServiceReportStatusFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;
		const data = yield call(ticketsReportStatusFetchRequest, payload);
		yield put(ticketsCallCenterServiceReportStatusFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}
// ---------------------------------------------------------------------------------------------------------
function* ticketCreate({ payload }) {
	try {
		payload.delivered_date =
			payload.delivered_date instanceof Object
				? payload.delivered_date.format("YYYY-MM-DD")
				: payload.delivered_date;

		const data = yield call(ticketCreateRequest, payload);
		if (data.success) {
			yield put(showSuccessMessage(intl.formatMessage({ id: "success.updated" })));
			yield put(reset('TicketAddForm'));
		}
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketUpdate({ payload }) {
	try {
		const data = yield call(ticketUpdateRequest, payload);
		if (data.success) {
			yield put(ticketFetchSuccess(data.success.result));
			if (data.success.result.status == "B") {
				yield put(showSuccessMessage(intl.formatMessage({ id: "success.updated.ticket.status.B" })));
			} else {
				yield put(showSuccessMessage(intl.formatMessage({ id: "success.updated" })));
			}
		}
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketVerifiedUpdate({ payload }) {
	try {
		const data = yield call(ticketVerifiedUpdateRequest, payload);
		if (data.success) {
			yield put(ticketFetchSuccess(data.success.result));
			yield put(showSuccessMessage(intl.formatMessage({ id: "success.updated" })));
		}
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketDelete({ payload: { id } }) {
	try {
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketCancel({ payload }) {
	try {
		const data = yield call(ticketCancelRequest, payload);
		if (data.success) {
			yield put(ticketFetchSuccess(data.success.result));
			yield put(showSuccessMessage(intl.formatMessage({ id: "success.canceled" })));
		}
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketsExportExcel({ payload }) {
	try {
		payload.from_created_date = payload.from_created_date instanceof Object ? payload.from_created_date.format("YYYY-MM-DD") : payload.from_created_date;
		payload.to_created_date = payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(ticketsExportExcelRequest, payload);
		FileSaver.saveAs(data, `tickets_${payload.type == "service" ? "aftersales" : payload.type}_${payload.source == 'survey' ? "qvoc" : payload.source}_${moment().format("DDMMYYYY")}.xlsx`);
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* ticketLogsUpdate({ payload }) {
	try {
		const data = yield call(ticketLogsUpdateRequest, payload);
		if (data.success) {
			yield put(ticketFetchSuccess(data.success.result));
			yield put(showSuccessMessage(intl.formatMessage({ id: "success.updated" })));
		}
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

// WATCHER
function* ticketFetchWatcher() {
	yield takeEvery(TICKET_FETCH, ticketFetch);
}

function* ticketsFetchWatcher() {
	yield takeEvery(TICKETS_FETCH, ticketsFetch);
}

function* ticketsServiceFetchWatcher() {
	yield takeEvery(TICKETS_SERVICE_FETCH, ticketsServiceFetch);
}

function* ticketsShowroomFetchWatcher() {
	yield takeEvery(TICKETS_SHOWROOM_FETCH, ticketsShowroomFetch);
}

function* ticketsServiceReportStatusFetchWatcher() {
	yield takeEvery(TICKETS_SERVICE_REPORT_STATUS_FETCH, ticketsServiceReportStatusFetch);
}

function* ticketsShowroomReportStatusFetchWatcher() {
	yield takeEvery(TICKETS_SHOWROOM_REPORT_STATUS_FETCH, ticketsShowroomReportStatusFetch);
}
// --------------------------------------------------------------------------------------------
function* ticketsHotSheetServiceFetchWatcher() {
	yield takeEvery(TICKETS_HOTSHEET_SERVICE_FETCH, ticketsHotSheetServiceFetch);
}

function* ticketsHotSheetShowroomFetchWatcher() {
	yield takeEvery(TICKETS_HOTSHEET_SHOWROOM_FETCH, ticketsHotSheetShowroomFetch);
}

function* ticketsHotSheetServiceReportStatusFetchWatcher() {
	yield takeEvery(TICKETS_HOTSHEET_SERVICE_REPORT_STATUS_FETCH, ticketsHotSheetServiceReportStatusFetch);
}

function* ticketsHotSheetShowroomReportStatusFetchWatcher() {
	yield takeEvery(TICKETS_HOTSHEET_SHOWROOM_REPORT_STATUS_FETCH, ticketsHotSheetShowroomReportStatusFetch);
}
// --------------------------------------------------------------------------------------------
function* ticketsCallCenterServiceFetchWatcher() {
	yield takeEvery(TICKETS_CALLCENTER_SERVICE_FETCH, ticketsCallCenterServiceFetch);
}

function* ticketsCallCenterShowroomFetchWatcher() {
	yield takeEvery(TICKETS_CALLCENTER_SHOWROOM_FETCH, ticketsCallCenterShowroomFetch);
}

function* ticketsCallCenterServiceReportStatusFetchWatcher() {
	yield takeEvery(TICKETS_CALLCENTER_SERVICE_REPORT_STATUS_FETCH, ticketsCallCenterServiceReportStatusFetch);
}

function* ticketsCallCenterShowroomReportStatusFetchWatcher() {
	yield takeEvery(TICKETS_CALLCENTER_SHOWROOM_REPORT_STATUS_FETCH, ticketsCallCenterShowroomReportStatusFetch);
}
// --------------------------------------------------------------------------------------------
function* ticketCreateWatcher() {
	yield takeEvery(TICKET_CREATE, ticketCreate);
}

function* ticketUpdateWatcher() {
	yield takeEvery(TICKET_UPDATE, ticketUpdate);
}

function* ticketVerifiedUpdateWatcher() {
	yield takeEvery(TICKET_VERIFIED_UPDATE, ticketVerifiedUpdate);
}

function* ticketDeleteWatcher() {
	yield takeEvery(TICKET_DELETE, ticketDelete);
}

function* ticketCancelWatcher() {
	yield takeEvery(TICKET_CANCEL, ticketCancel);
}

function* ticketsExportExcelWatcher() {
	yield takeEvery(TICKETS_EXPORT_EXCEL, ticketsExportExcel);
}

function* ticketLogsUpdateWatcher() {
	yield takeEvery(TICKET_LOGS_UPDATE, ticketLogsUpdate);
}

export default function* rootSaga() {
	yield all([
		fork(ticketFetchWatcher),
		fork(ticketsFetchWatcher),
		fork(ticketsServiceFetchWatcher),
		fork(ticketsShowroomFetchWatcher),
		fork(ticketsServiceReportStatusFetchWatcher),
		fork(ticketsShowroomReportStatusFetchWatcher),
		fork(ticketCreateWatcher),
		fork(ticketUpdateWatcher),
		fork(ticketVerifiedUpdateWatcher),
		fork(ticketDeleteWatcher),
		fork(ticketCancelWatcher),
		fork(ticketsExportExcelWatcher),
		fork(ticketsHotSheetServiceFetchWatcher),
		fork(ticketsHotSheetShowroomFetchWatcher),
		fork(ticketsHotSheetServiceReportStatusFetchWatcher),
		fork(ticketsHotSheetShowroomReportStatusFetchWatcher),
		fork(ticketsCallCenterServiceFetchWatcher),
		fork(ticketsCallCenterShowroomFetchWatcher),
		fork(ticketsCallCenterServiceReportStatusFetchWatcher),
		fork(ticketsCallCenterShowroomReportStatusFetchWatcher),
		fork(ticketLogsUpdateWatcher)
	]);
}
